<script>
import { mapActions } from 'vuex'

import MultiSelect from 'vue-multiselect'

import InputWrapper from '@/components/UI/FormGroupWrappers/InputWrapper.vue'

export default {
	name: 'SelectReservoirsList',
	components: {
		MultiSelect,
		InputWrapper,
	},
	props: {
		withTitle: {
			type: Boolean,
			default: true,
		},
		max: {
			type: Number,
			default: null,
		},
		placeholder: {
			type: String,
			default: '',
		},
		errors: {
			type: Object,
			default: null,
		},
		name: {
			type: String,
			default: '',
		},
		filters: {
			type: Object,
			default: () => ({}),
		},
		required: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Object, Array],
			default: null,
		},
		confinesValue: {
			type: Array,
			default: () => [],
		},
		// Если передан id субъекта — список ограничен водоёмами его действующих квот,
		// иначе используется общий справочник водоёмов.
		userId: {
			type: [Number, String],
			default: null,
		},
		watchValue: null,
		watchValues: {
			type: Array,
			default: () => [],
		},
	},
	emits: ['input'],
	computed: {
		modelValue: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			},
		},
		options() {
			let ponds = this.userId
				? this.$store.state.catalogs.userPonds || []
				: this.$store.state.catalogs.ponds || []
			// Водоёмы субъекта приходят без регионов и районов — по ним не фильтруем,
			// список и без того сужен до квот конкретного субъекта.
			// Filter by district if provided
			if (!this.userId && this.filters && this.filters.districts && this.filters.districts.length) {
				ponds = ponds.filter(
					(pond) =>
						pond.districts && pond.districts.some((d) => this.filters.districts.includes(d.id)),
				)
			}
			// Optionally, filter by region if provided
			if (!this.userId && this.filters && this.filters.regions && this.filters.regions.length) {
				ponds = ponds.filter(
					(pond) => pond.regions && pond.regions.some((r) => this.filters.regions.includes(r.id)),
				)
			}
			// Filter by confinesValue (quotas)
			ponds = ponds.filter((item) => !this.confinesValue?.some((confine) => confine.id === item.id))
			const allItems = [
				{
					source: this.$t('labels.restItems'),
					items: ponds,
				},
			]
			if (this.confinesValue?.length) {
				allItems.unshift({
					source: this.$t('labels.byQuota'),
					items: this.confinesValue,
				})
			}
			return allItems
		},
	},
	watch: {
		userId() {
			this.loadPonds()
		},
		watchValues: {
			handler(newValue, oldValue) {
				if (this.userId) return
				if (!this.watchValues?.length || JSON.stringify(newValue) === JSON.stringify(oldValue))
					return
				if (
					Object.entries(this.filters).every(([_, value]) => value?.length && value.every((i) => i))
				) {
					this._fetchPondList(this.filters)
				}
			},
		},
	},
	methods: {
		...mapActions(['_fetchPondList', '_fetchUserPondList']),
		loadPonds() {
			return this.userId ? this._fetchUserPondList(this.userId) : this._fetchPondList()
		},
	},
	async beforeMount() {
		// if (!this.watchValues?.length) await this._fetchPondList()
		await this.loadPonds()
	},
}
</script>

<template>
	<InputWrapper
		class="select-region"
		:title="withTitle ? '' : ''"
		:is-error="errors && errors.$error"
		:error="errors && !errors.required ? $t('system_message.required_message') : ''"
	>
		<MultiSelect
			track-by="id"
			label="title"
			class="multiselect__check"
			:max="multiple && max"
			:preserve-search="true"
			:required="required"
			:multiple="multiple"
			:close-on-select="!multiple"
			:placeholder="placeholder"
			:disabled="disabled"
			:options="options"
			group-label="source"
			group-values="items"
			:group-select="false"
			v-model="modelValue"
		>
			<template slot="option" slot-scope="{ option }">
				<span v-if="option.$isLabel && confinesValue?.length" class="group-title">{{
					option.$groupLabel
				}}</span>
				<span v-else>{{ option.title }}</span>
			</template>
			<template slot="noResult">{{ $t('components.not_found') }}</template>
			<template slot="noOptions">{{ $t('components.not_found') }}</template>
			<template slot="placeholder">{{ placeholder || $t('placeholder.choose') }}</template>
		</MultiSelect>
	</InputWrapper>
</template>

<style>
.select-region .multiselect__tags {
	padding-left: 20px;
	border-radius: 5px;
	background: #ffffff;
	border: 1px solid #157fee !important;
	font-weight: 400;
	font-size: 14px;
	color: #0a091d;
	line-height: 1.2;
	width: 100%;
}

.select-region .multiselect--disabled .multiselect__tags {
	border: 1px solid #d3e7fb;
}

.select-region .multiselect--disabled .multiselect__placeholder {
	margin-bottom: 0;
}

.select-region .multiselect__single {
	margin-bottom: 0;
}

.select-region .input-body--error.input-body .multiselect__tags {
	border-color: #f3574d;
}

.select-region .input-body--error + .input-required {
	display: block;
}
</style>
